<template>
  <v-app v-if="time" id="app" :style="{ '--vh': cssVariables.vh }">
    <v-app-bar v-if="showAppBar" density="compact" flat :height="60">
      <div class="logoPrestige" v-if="!isCompactWindow">
        <img :src="logo" alt="Patiently Logo" width="120" height="40" />
      </div>
      <div class="app-bar-text">
        {{ this.$dayjs(this.time).format('hh:mm A') }}
      </div>
    </v-app-bar>
    <v-main>
      <v-container class="fullHeight container" fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {mapState} from 'vuex';


declare interface BaseData {
  clock: number | undefined;
  userId: string | null;
  cssVariables: { [key: string]: string };
  logo: any;
  showAppBar: boolean;
}

export default defineComponent({
  name: 'App',
  components: {},
  data(): BaseData {
    return {
      logo: require('@/assets/logoPrestige.svg'),
      clock: undefined,
      userId: null,
      cssVariables: { vh: '0' },
      showAppBar: true,
    };
  },
  computed: {
    ...mapState({
      time: (state: any) => state.time,
      user: (state: any) => state.auth.user,
    }),
    isCompactWindow() {
      return window.innerWidth <= 1162;
    },
  },
  created() {
    this.setClock();
    this.userId = this.$storage.getUserId();
    if (this.userId && !this.user) { this.login(); }
    const styleHeading = 'font-size: 38px; color: red; text-shadow: 1px 1px 1px black;';
    const styleText =
        'font-size: 30px; color: red; text-shadow: 1px 1px 1px black; background: yellow;';
    /* eslint-disable-next-line */
    console.log(
        `%c⚠️ WARNING ⚠️\n` +
        `%cPlease do not copy and paste anything here; ` +
        `you might become a victim of a hacker attack. ` +
        `Learn more about Self-XSS: https://en.wikipedia.org/wiki/Self-XSS`,
        styleHeading,
        styleText,
    );

  },
  mounted() {
    this.setCssVariableVh();

    this.showAppBar = !this.$route.path.startsWith('/booking/');

    window.addEventListener('resize', () => this.setCssVariableVh);
  },
  beforeUnmount() {
    clearInterval(this.clock);
    window.removeEventListener('resize', () => this.setCssVariableVh);
  },
  methods: {
    async login(): Promise<void> {
      // Hydrate from cache immediately (synchronous — unblocks rendering)
      const cached = this.$storage.getCachedUser();
      if (cached) {
        this.$store.commit('setUser', { data: cached.user });
        this.$store.commit('setPermissions', { permissions: cached.permissions });
      }
      const officeId = this.$storage.getOfficeId();
      this.$store.commit('setOffice', { data: officeId });

      // Revalidate in background (don't block rendering)
      this.$store.dispatch('LOAD_USER', { userId: this.userId });
    },
    setClock(): void {
      this.clock = setInterval(() => {
        this.$store.dispatch('loadTime');
      }, 1000);
    },
    setCssVariableVh(): void {
      this.cssVariables.vh = `${window.innerHeight * 0.01}px`;
      document.documentElement.style.setProperty(
        '--vh',
        `${window.innerHeight * 0.01}px`,
      );
    },
  },
});
</script>

<style>

.app-bar-text {
  @apply w-full text-xl text-gray-darker text-center font-medium;
}

#app {
  overflow: hidden;
  background-color: #f5f6f7 !important;
  min-height: 100dvh;
}

.fullHeight {
  height: 100%;
}

.container {
  padding: 0;
}

::-webkit-scrollbar {
  display: none;
  width: 7px;
  height: 7px;
  background-color: transparent;
}

.v-dialog {
  box-shadow: none;
}

.v-dialog > .v-overlay__content {
  box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
  0 24px 38px 3px rgba(0, 0, 0, 0.14),
  0 9px 46px 8px rgba(0, 0, 0, 0.12) !important;
  border-radius: 8px;
}
.v-dialog > .v-overlay__content > * {
  border-radius: 8px;
}
</style>
